<!-- src/components/Paginator.svelte -->
<script>
    export let itemsPerPageOptions;
    export let totalRecords = 0;
    export let currentPage = 1;
    export let perPage = 10;
    export let onPageChange;
    export let onItemsPerPageChange;
    import { t, _ } from 'svelte-i18n';
  
    let totalPages;
    $: totalPages = Math.ceil(totalRecords / perPage);
  </script>
  
  <div class="flex justify-between items-center mt-4">
    <button
      on:click={() => onPageChange(-1)}
      disabled={currentPage === 1 || totalRecords === 0}
      class="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
    >
      {$t('common.previous')}
    </button>
  
    <span>{$_('common.pageOf', { values: { current: currentPage, total: Math.ceil(totalRecords / perPage) } })}</span>
  
    <div class="flex items-center gap-2">
      <label for="itemsPerPage" class="text-sm">{$t('common.itemsPerPage')}</label>
      <select
          id="itemsPerPage" 
          bind:value={perPage}
          on:change={(e) => onItemsPerPageChange(e.target.value)}
          class="px-2 py-1 border rounded"
      >
          {#each itemsPerPageOptions as option}
              <option value={option}>{option}</option>
          {/each}
      </select>
    </div>
  
    <button
      on:click={() => onPageChange(1)}
      disabled={currentPage === totalPages || totalRecords === 0}
      class="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
    >
      {$t('common.next')}
    </button>
  </div>
  